export default {
    routerName: '登録',
    user: {
        loginName: '账号',
        password: '密码',
        captcha: '验证码',
        name: '姓名',
        email: '邮箱',
        mobile: '电话',
        sex: '性别',
        male: '男性',
        female: '女性',
    },
};
